export enum DesignationType {
  ProjectObject  = 0,
  ProjectSubobject = 1,
  LocationGroup = 2
}
